import React from 'react';
import { defaultSidebarItems } from "./Sidebar-items";
import classNames from "classnames";
import "./Sidebar-style.css"; // Importa o CSS
import { Link } from "react-router-dom";

const ArrowLeft = () => {
    return (
        <img src="/images/ArrowLeft.svg" width={23} height={23} alt="Expandir" />
    );
};

const ArrowRight = () => {
    return (
        <img src="/images/ArrowRight.svg" width={23} height={23} alt="Contrair" />
    );
};

const Sidebar = (props) => {
    return (
        <div
            className={classNames({
                "sidebar-container": true,
                "transition-all duration-300 ease-in-out": true,
                "w-[150px]": !props.collapsed,
                "w-[41.6px]": props.collapsed,
                "-translate-x-full": !props.shown,
                "box-shadow": true,
            })}
        >
            <div className="sidebar-content">
                <div className="sidebar-logo">
                    <img src="images/unisuam-logo.svg" width={30} height={19} alt="Abrir" />
                </div>
                <nav className="sidebar-nav">
                    <ul className="sidebar-items">
                        {defaultSidebarItems?.map((item, index) => {
                            return (
                                <li
                                    key={index}
                                    className={classNames({
                                        "sidebar-item": true,
                                        "collapsed-item": props.collapsed, // Adiciona classe condicional
                                    })}
                                >
                                    <Link to={item.href}>
                                        <span className="sidebar-link">
                                            {item.icon}
                                            <span className="text-label">{!props.collapsed && item.label}</span>
                                        </span>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
                <div className="sidebar-toggle">
                    <button
                        className="toggle-button"
                        onClick={() => props.setCollapsed(!props.collapsed)}
                    >
                        {props.collapsed ? <ArrowLeft /> : <ArrowRight />}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
